module.exports = __webpack_public_path__ + "2e9dbf4de3893afb4572b7f77079dc66.svg";